/* eslint-disable react/no-unknown-property */
// 给查询方案用的
import React, { Component } from 'react';
import classNames from 'classnames';
import MoveButton from './moveButton';
import { Checkbox } from '@platform/base';
import PropTypes from 'prop-types';
import { getMultiLang, getSysFieldid } from '@platform/api';
import './index.less';
import './tree.less';
export default class TreeToTreeTransfer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            json: {},
            leftCheckedNodes: [], // 左选中节点
            leftCheckedNum: 0, // 左分子
            leftAllNum: 0, // 左分母 
            currentLeftCheckedNum: 0, // 当前左分子
            currentLeftAllNum: 0, // 当前左分母
            rightCheckedNodes: [], // 右选中节点
            rightCheckedNum: 0, // 右分子
            rightAllNum: 0, // 右分母
            currentRightCheckedNum: 0, // 当前右分子
            currentRightAllNum: 0, // 当前右分母
            includeAll: {}, // 包含全部
            includeSon: {}, // 包含下级
        };
    }

    // eslint-disable-next-line react/no-deprecated
    componentWillMount() {
        // 初始化多语
        let callback = json => {
            this.setState({ json });
        };
        getMultiLang({ moduleId: 'container_transfer', callback });
    }
    // 合并去重
    mergeAndUniqueByPk = (arr1, arr2) => {
        const map = new Map();
        arr1.forEach(item => map.set(item.refpk, item));
        arr2.forEach(item => !map.has(item.refpk) && map.set(item.refpk, item));
        return Array.from(map.values());
    }
    // 获取分母
    getDenominator = ({ treeList, rootPk }) => {
        // 如果只要keys 不需要rootPk
        const allKeys = new Set();
        const allNodes = [];
        if (treeList.length > 0) {
            treeList.forEach(item => {
                const { refpk, isleaf, fictitious } = item;
                if ((isleaf || fictitious === false) && !allKeys.has(refpk)) {
                    allKeys.add(refpk);
                    rootPk && allNodes.push(this.getNode(item, rootPk));
                }
            });

        }
        return {
            allNodes,
            allKeys: [...allKeys],
        };
    }
    // 获取分子
    getNumerator = ({ treeList, rootPk, keys, syncTree, isRight }) => {
        // 如果只要keys 不需要rootPk
        const checkedKeys = new Set();
        const checkedNodes = [];

        if (treeList.length > 0) {
            keys.forEach(key => {
                const item = syncTree.getItem(treeList, key) || {};
                const { refpk, isleaf, fictitious } = item;
                if ((isleaf || fictitious === false) && !checkedKeys.has(key)) {
                    checkedKeys.add(refpk);
                    rootPk && checkedNodes.push(this.getNode(item, rootPk, isRight));
                }
            });

        }
        return {
            checkedNodes,
            checkedKeys: [...checkedKeys],
        };
    }
    // 获取节点
    getNode = (node, rootPk, isRight) => {
        let { pid, refname, refcode, refpk, fictitious, oldrefpk } = node;
        return {
            refname,
            refcode,
            oldrefpk: oldrefpk ? oldrefpk : refpk,
            refpk: (oldrefpk || isRight) ? refpk : rootPk + refpk,
            pid: isRight ? pid : rootPk,
            fictitious,
            isleaf: true,
        };
    }
    // 获取所有下级
    getAllChildren = (treeData, rootPk) => {
        let pks = [];
        let nodes = [];
        const { isleaf, fictitious } = treeData;
        if (isleaf || fictitious === false) {
            pks.push(treeData.refpk);
            nodes.push(this.getNode(treeData, rootPk));
        }
        treeData?.children?.forEach(item => {
            const { key, isleaf, fictitious } = item;
            if (isleaf || fictitious === false) {
                pks.push(key);
                nodes.push(this.getNode(item, rootPk));
            }
            if (item.children) {
                const obj = this.getAllChildren(item, rootPk);
                pks.push(...obj.pks);
                nodes.push(...obj.nodes);
            }
        });
        return {
            pks,
            nodes,
        };
    };
    // 获取当前点击节点的所涉及的pk， 根据类型不同，返回值不同
    getCheckByType = (nodeInfo, rootPk, type) => {
        // self, all, son
        let pks = [];
        let nodes = [];
        const { isleaf, fictitious } = nodeInfo;
        switch (type) {
            case 'self': // 只选当前节点
                if (isleaf || fictitious === false) {
                    pks.push(nodeInfo.refpk);
                    nodes.push(this.getNode(nodeInfo, rootPk));
                }
                break;
            case 'son': // 包含直接下级
                if (isleaf || fictitious === false) {
                    pks.push(nodeInfo.refpk);
                    nodes.push(this.getNode(nodeInfo, rootPk));
                }
                nodeInfo?.children?.forEach(item => {
                    const { key, isleaf, fictitious } = item;
                    if (isleaf || fictitious === false) {
                        pks.push(key);
                        nodes.push(this.getNode(item, rootPk));
                    }
                });
                break;
            case 'all': // 包含所有下级
                const obj = this.getAllChildren(nodeInfo, rootPk);
                pks = obj.pks;
                nodes = obj.nodes;
                break;
            default:
                break;
        }
        return {
            pks,
            nodes,
        };
    }
    // 右穿 包含所以右穿 和 当前右穿
    moveRight = nodes => {
        let {
            activeKey,
            tabPks,
            leftTreeMoudleId,
            rightTreeMoudleId,
            tabNames,
            syncTree,
        } =
            this.props;
        const rightTreeData = syncTree.getTreeData(rightTreeMoudleId);
        const rootPk = tabPks[activeKey - 1];
        const currentTreeRoot = {
            refpk: rootPk,
            isleaf: false,
            refname: tabNames[rootPk],
            attrcode: rootPk,
            label: tabNames[rootPk],
            fictitious: true,
            pid: '__root__',
        };
        // 如果右边没树，直接创建树
        if (rightTreeData.length === 0) {
            const treeData = syncTree.createTreeData([currentTreeRoot, ...nodes]);
            syncTree.setSyncTreeData(rightTreeMoudleId, treeData);
        } else {
            const currentTree = syncTree.getSyncTreeValue(rightTreeMoudleId, rootPk);
            if (currentTree) {
                // 更新子节点
                syncTree.updateNodeChildren(
                    rightTreeMoudleId,
                    this.mergeAndUniqueByPk(currentTree.children, nodes),
                    tabPks[activeKey - 1],
                );
            } else {
                // 加兄弟节点
                const treeData = syncTree.createTreeData([currentTreeRoot, ...nodes]);
                syncTree.addBrotherNode(rightTreeMoudleId, treeData);
            }
        }
        // 展开对应右树
        syncTree.openNodeByPk(rightTreeMoudleId, rootPk);
        // 选中禁用
        nodes.forEach(item => {
            syncTree.setNodeDisable(leftTreeMoudleId, true, item.oldrefpk);
        });
        // 选中清空
        syncTree.setNodeChecked(leftTreeMoudleId, []);
        syncTree.setNodeChecked(rightTreeMoudleId, []);
        // 右树分母更新, 左侧选中清空
        const treeList = syncTree.getTreeToList(rightTreeMoudleId);
        const { allKeys } = this.getDenominator({ treeList });
        this.setState({
            currentLeftCheckedNum: 0,
            currentRightCheckedNum: 0,
            rightAllNum: allKeys.length,
            rightCheckedNodes: [],
            rightCheckedNum: 0,
            leftCheckedNodes: [],
            leftCheckedNum: 0,
        });
    }
    // 穿梭操作
    handleMove = direction => {
        let {
            activeKey,
            tabPks,
            leftTreeMoudleId,
            rightTreeMoudleId,
            syncTree,
        } =
            this.props;
        let {
            rightAllNum,
            leftCheckedNodes,
            rightCheckedNodes,
        } = this.state;
        const rootPk = tabPks[activeKey - 1];
        let treeList = [];
        // 左右都清空搜素值
        if (syncTree.getSyncTreeSearchVal(leftTreeMoudleId)) {
            syncTree.getSearchChangeEven('', leftTreeMoudleId);
        }
        if (syncTree.getSyncTreeSearchVal(rightTreeMoudleId)) {
            syncTree.getSearchChangeEven('', rightTreeMoudleId);
        }

        switch (direction) {
            case 'right':
                this.moveRight(leftCheckedNodes);
                break;
            case 'allRight':
                treeList = syncTree.getTreeToList(leftTreeMoudleId) || [];
                let { allNodes } = this.getDenominator({ treeList, rootPk });
                this.moveRight(allNodes);
                break;
            case 'left':
                const curentpks = [];
                let deleteSum = 0;
                rightCheckedNodes.forEach(item => {
                    syncTree.delNodeSuceess(rightTreeMoudleId, item.refpk, true);
                    deleteSum++;
                    if (item.refpk.startsWith(rootPk)) {
                        curentpks.push(item.oldrefpk);
                    }
                });
                tabPks.forEach(tabkey => {
                    const tabTree = syncTree.getSyncTreeValue(rightTreeMoudleId, tabkey);
                    if (tabTree && tabTree?.children?.length === 0) {
                        syncTree.delNodeSuceess(rightTreeMoudleId, tabkey, true);
                    }
                });
                syncTree.setNodeDisable(leftTreeMoudleId, false, curentpks);
                syncTree.setNodeChecked(rightTreeMoudleId, []);
                syncTree.setNodeChecked(leftTreeMoudleId, []);
                this.setState({
                    currentRightCheckedNum: 0,
                    rightCheckedNodes: [],
                    rightCheckedNum: 0,
                    rightAllNum: rightAllNum - deleteSum,
                });
                break;
            case 'allLeft':
                const currentTree = syncTree.getSyncTreeValue(rightTreeMoudleId, rootPk);
                const allpks = currentTree?.children.map(item => {
                    return item.oldrefpk;
                }) || [];
                syncTree.setNodeDisable(leftTreeMoudleId, false, allpks);
                syncTree.setSyncTreeData(rightTreeMoudleId, []);
                syncTree.setNodeChecked(rightTreeMoudleId, []);
                syncTree.setNodeChecked(leftTreeMoudleId, []);
                this.setState({
                    currentRightCheckedNum: 0,
                    rightCheckedNodes: [],
                    rightCheckedNum: 0,
                    rightAllNum: 0,
                });
                break;
            default:
                break;
        }
    };

    // 左侧 相关事件

    /**
     * 左侧 已选 checkbox change 事件
     * @param {*} value 
     */
    onLeftCheckChange = value => {
        let {
            leftTreeMoudleId,
            syncTree,
            tabPks,
            activeKey,
        } = this.props;
        let { leftCheckedNodes } = this.state;
        const rootPk = tabPks[activeKey - 1];
        const treeList = syncTree.getTreeToList(leftTreeMoudleId) || [];
        const keys = [];
        const oldCheckedKeys = [];
        treeList.forEach(e => {
            keys.push(e.refpk);
        });
        leftCheckedNodes.forEach(e => {
            oldCheckedKeys.push(e.refpk);
        });
        if (value) {
            let { checkedKeys, checkedNodes } = this.getNumerator({ treeList, keys, syncTree, rootPk });
            checkedNodes = this.mergeAndUniqueByPk(leftCheckedNodes, checkedNodes);
            syncTree.setNodeChecked(leftTreeMoudleId, keys);
            this.setState({
                currentLeftAllNum: treeList.length,
                currentLeftCheckedNum: treeList.length,
                leftCheckedNodes: checkedNodes,
                leftCheckedNum: checkedKeys.length,
            });
        } else {
            const checkedKeys = [];
            const checkedNodes = leftCheckedNodes.filter(item => {
                if (!keys.includes(item.oldrefpk)) {
                    checkedKeys.push(item.oldrefpk);
                    return item;
                }
            });
            syncTree.setNodeChecked(leftTreeMoudleId, checkedKeys);
            this.setState({
                currentLeftAllNum: treeList.length,
                currentLeftCheckedNum: 0,
                leftCheckedNodes: checkedNodes,
                leftCheckedNum: checkedKeys.length,
            });
        }
    }
    /**
     * 左侧 树勾选节点事件
     * @param {*} func 
     * @param {*} checkedPk 
     * @param {*} checkObj 
     * @param {*} saveCheckedKeys 
     */
    onCheckEveByLeft = (func, checkedPk, checkObj, node) => {
        //如果是只有一个包含全部
        let {
            leftTreeMoudleId,
            showInclude,
            syncTree,
            tabPks,
            activeKey,
        } = this.props;
        const rootPk = tabPks[activeKey - 1];
        let {
            includeSon,
            includeAll,
            leftCheckedNodes,
        } = this.state;
        const curentKey = checkObj.node.props.refpk;
        const treeData = syncTree.getTreeData(leftTreeMoudleId);
        const nodeInfo = syncTree.getItem(treeData, curentKey);
        // const nodeInfo = syncTree.getSyncTreeValue(leftTreeMoudleId, curentKey);
        let nodeObj = {};
        if (showInclude && includeSon[rootPk]) {
            nodeObj = this.getCheckByType(nodeInfo, rootPk, 'son');
        } else if ((showInclude && includeAll[rootPk]) || !showInclude) {
            nodeObj = this.getCheckByType(nodeInfo, rootPk, 'all');
        } else {
            nodeObj = this.getCheckByType(nodeInfo, rootPk, 'self');
        }
        // nodeObj 含有 无意义节点

        let checkedKeys = [];
        let checkedNodes = [];
        if (checkObj.checked) {
            checkedNodes = this.mergeAndUniqueByPk(leftCheckedNodes, nodeObj.nodes);
            checkedKeys = checkedNodes.map(i => i.oldrefpk);
            syncTree.setNodeChecked(leftTreeMoudleId, checkedKeys);
        } else {
            checkedNodes = leftCheckedNodes.filter(item => {
                if (!nodeObj.pks.includes(item.oldrefpk)) {
                    checkedKeys.push(item.oldrefpk);
                    return item;
                }
            });
            syncTree.setNodeChecked(leftTreeMoudleId, checkedKeys);
        }
        const treeList = syncTree.getTreeToList(leftTreeMoudleId) || [];
        const currentCheckedKeys = syncTree.getCheckedKeys(leftTreeMoudleId) || [];
        this.setState({
            leftCheckedNodes: checkedNodes,
            leftCheckedNum: checkedKeys.length,
            currentLeftAllNum: treeList.filter(i => (i.isleaf && i.fictitious === false)).length,
            currentLeftCheckedNum: currentCheckedKeys.length,
        });
    }
    /**
     * 左侧 树设值事件
     */
    onSetTreeDataEveByLeft = () => {
        let {
            leftTreeMoudleId,
            syncTree,
            selectedPks,
            tabPks,
            activeKey,
        } = this.props;
        const rootPk = tabPks[activeKey - 1];
        if (selectedPks.length > 0) {
            selectedPks.forEach(item => {
                syncTree.setNodeDisable(leftTreeMoudleId, true, item.replace(rootPk, ''));
            });
        }
        const treeList = syncTree.getTreeToList(leftTreeMoudleId) || [];
        const { allKeys } = this.getDenominator({ treeList });
        this.setState({
            leftCheckedNodes: [],
            leftCheckedNum: 0,
            currentLeftCheckedNum: 0,
            currentLeftAllNum: allKeys.length,
            leftAllNum: allKeys.length,
        });
    }
    /**
     * 左侧 搜索值改变事件
     */
    searchChangeEveByLeft = () => {
        let {
            leftTreeMoudleId,
            syncTree,
        } = this.props;
        const treeList = syncTree.getTreeToList(leftTreeMoudleId) || [];
        const checkedKeys = syncTree.getCheckedKeys(leftTreeMoudleId) || [];
        this.setState({
            currentLeftAllNum: treeList.filter(i => (i.isleaf && i.fictitious === false)).length,
            currentLeftCheckedNum: checkedKeys.length,
        });
    }
    /**
     * 左侧 搜索框清空按钮回调
     */
    clearSearchValByLeft = () => {
        let {
            leftTreeMoudleId,
            syncTree,
        } = this.props;
        let {
            leftCheckedNodes,
            leftAllNum,
            leftCheckedNum,
        } = this.state;
        const checkedKeys = leftCheckedNodes.map(item => item.oldrefpk);
        syncTree.setNodeChecked(leftTreeMoudleId, checkedKeys);
        this.setState({
            currentLeftAllNum: leftAllNum,
            currentLeftCheckedNum: leftCheckedNum,
        });
    }

    // 右侧 相关事件

    /**
     * 右侧 已选 checkbox change 事件
     * @param {*} value 
     */
    onRightCheckChange = value => {
        let {
            rightTreeMoudleId,
            syncTree,
            tabPks,
            activeKey,
        } = this.props;
        let { rightCheckedNodes } = this.state;
        const rootPk = tabPks[activeKey - 1];
        const treeList = syncTree.getTreeToList(rightTreeMoudleId) || [];
        const keys = [];
        const oldCheckedKeys = [];
        treeList.forEach(e => {
            keys.push(e.refpk);
        });
        rightCheckedNodes.forEach(e => {
            oldCheckedKeys.push(e.refpk);
        });
        if (value) {
            let { checkedKeys, checkedNodes } = this.getNumerator({ treeList, keys, syncTree, rootPk, isRight: true });
            checkedNodes = this.mergeAndUniqueByPk(rightCheckedNodes, checkedNodes);
            syncTree.setNodeChecked(rightTreeMoudleId, checkedKeys);
            this.setState({
                currentRightAllNum: treeList.length,
                currentRightCheckedNum: treeList.length,
                rightCheckedNodes: checkedNodes,
                rightCheckedNum: checkedKeys.length,
            });
        } else {
            const checkedKeys = [];
            const checkedNodes = rightCheckedNodes.filter(item => {
                if (!keys.includes(item.refpk)) {
                    checkedKeys.push(item.refpk);
                    return item;
                }
            });
            syncTree.setNodeChecked(rightTreeMoudleId, checkedKeys);
            this.setState({
                currentRightAllNum: treeList.length,
                currentRightCheckedNum: 0,
                rightCheckedNodes: checkedNodes,
                rightCheckedNum: checkedKeys.length,
            });
        }
    }
    /**
     * 右侧 树勾选节点事件
     * @param {*} func 
     * @param {*} checkedPk 
     * @param {*} checkObj 
     * @param {*} saveCheckedKeys 
     */
    onCheckEveByRight = (func, checkedPk, checkObj, node) => {
        let {
            rightTreeMoudleId,
            syncTree,
            tabPks,
            activeKey,
        } = this.props;
        let { rightCheckedNodes } = this.state;
        const rootPk = tabPks[activeKey - 1];
        let checkedKeys = [];
        let checkedNodes = [];
        if (checkObj.checked) {
            const treeList = syncTree.getTreeToList(rightTreeMoudleId) || [];
            const nodeObj = this.getNumerator({ treeList, keys: checkedPk, syncTree, rootPk, isRight: true });
            syncTree.setNodeChecked(rightTreeMoudleId, node);
            checkedKeys = node;
            checkedNodes = this.mergeAndUniqueByPk(rightCheckedNodes, nodeObj.checkedNodes);
        } else {
            const curentKey = checkObj.node.props.refpk;
            const treeData = syncTree.getTreeData(rightTreeMoudleId);
            const nodeInfo = syncTree.getItem(treeData, curentKey);

            const { pks } = this.getAllChildren(nodeInfo, rootPk);
            checkedNodes = rightCheckedNodes.filter(item => {
                if (!pks.includes(item.refpk)) {
                    checkedKeys.push(item.refpk);
                    return item;
                }
            });
            syncTree.setNodeChecked(rightTreeMoudleId, checkedKeys);
        }
        const treeList = syncTree.getTreeToList(rightTreeMoudleId) || [];
        const currentRightAll = [], shadowNodelist = [];
        treeList.forEach(i => {
            if(i.isleaf && i.fictitious === false){
                currentRightAll.push(i);
            }else{
                shadowNodelist.push(i.attrcode);
            }
        });
        const currentCheckedKeys = syncTree.getCheckedKeys(rightTreeMoudleId) || [];
        this.setState({
            currentRightAllNum: currentRightAll.length,
            currentRightCheckedNum: currentCheckedKeys.filter(i => !shadowNodelist.includes(i)).length,
            rightCheckedNodes: checkedNodes,
            rightCheckedNum: checkedNodes.length,
        });
    }
    /**
     * 右侧 树设值事件
     */
    onSetTreeDataEveByRight = () => {
        let {
            rightTreeMoudleId,
            syncTree,
        } = this.props;
        const treeList = syncTree.getTreeToList(rightTreeMoudleId) || [];
        const { allKeys } = this.getDenominator({ treeList });
        this.setState({
            rightAllNum: allKeys.length,
            currentRightAllNum: allKeys.length,
        });
    }
    /**
     * 右侧 搜索值改变事件
     */
    searchChangeEveByRight = () => {
        let {
            rightTreeMoudleId,
            syncTree,
        } = this.props;
        const treeList = syncTree.getTreeToList(rightTreeMoudleId) || [];
        const checkedKeys = syncTree.getCheckedKeys(rightTreeMoudleId) || [];
        this.setState({
            currentRightAllNum: treeList.filter(i => (i.isleaf && i.fictitious === false)).length,
            currentRightCheckedNum: checkedKeys.length,
        });
    }
    /**
     * 右侧 搜索框清空按钮回调
     */
    clearSearchValByRight = () => {
        let {
            rightTreeMoudleId,
            syncTree,
        } = this.props;
        let {
            rightAllNum,
            rightCheckedNum,
            rightCheckedNodes,
        } = this.state;
        const checkedKeys = rightCheckedNodes.map(item => item.refpk);
        syncTree.setNodeChecked(rightTreeMoudleId, checkedKeys);
        this.setState({
            currentRightAllNum: rightAllNum,
            currentRightCheckedNum: rightCheckedNum,
        });
    }
    // Render 相关
    // 穿梭按钮组
    renderOperation = () => {
        let {
            operations,
            renderOperation,
            disabled,
        } = this.props;

        let {
            json,
            rightCheckedNum,
            rightAllNum,
            leftCheckedNum,
            leftAllNum,
        } = this.state;

        return (
            <MoveButton
                left={{
                    text: operations[0],
                    active: !disabled && (rightCheckedNum > 0),
                    move: this.handleMove.bind(this, 'left'),
                }}
                right={{
                    text: operations[1],
                    active: !disabled && (leftCheckedNum > 0),
                    move: this.handleMove.bind(this, 'right'),
                }}
                allLeft={{
                    text: operations[2],
                    move: this.handleMove.bind(this, 'allLeft'),
                    active: !disabled && (rightAllNum > 0),
                }}
                allRight={{
                    text: operations[3],
                    active: !disabled && (leftAllNum > 0),
                    move: this.handleMove.bind(this, 'allRight'),
                }}
                langJson={json}
                direction={'horizontal'}
                renderOperation={renderOperation}
            />
        );
    }
    // 左侧头部
    renderLeftHeader = () => {
        const { disabled } = this.props;
        const {
            json,
            leftAllNum,
            leftCheckedNum,
            currentLeftAllNum,
            currentLeftCheckedNum,
        } = this.state;
        return (
            <div className="ncc-transfer-list-header">
                {
                    <Checkbox
                        fieldid={getSysFieldid('transfer_header_left')}
                        disabled={disabled}
                        checked={
                            currentLeftCheckedNum &&
                            currentLeftCheckedNum ===
                            currentLeftAllNum
                        }
                        indeterminate={
                            currentLeftCheckedNum &&
                            currentLeftCheckedNum <
                            currentLeftAllNum
                        }
                        onChange={this.onLeftCheckChange}
                    />
                }
                <span className="ncc-transfer-list-header-selected">
                    {json['container-transfer-select']}{' '}
                    {`(${leftCheckedNum}/${leftAllNum})`}
                </span>
            </div>
        );
    }
    // 左侧包含
    renderInclude = () => {
        const {
            disabled,
            tabPks,
            activeKey,
        } = this.props;
        const {
            json,
            includeAll,
            includeSon,
        } = this.state;
        const rootPk = tabPks[activeKey - 1];
        return (
            <span className='include-box' >
                <Checkbox
                    disabled={disabled}
                    checked={!!includeAll[rootPk]}
                    onChange={value => {
                        if (value) {
                            this.setState({ includeSon: { ...includeSon, [rootPk]: false } });
                        }
                        this.setState({ includeAll: { ...includeAll, [rootPk]: value } });
                    }}
                />
                <span className="include-all" title={json['container-transfer-0010'] || '包含全部'}>
                    {json['container-transfer-0010'] || '包含全部'}
                </span>
                <Checkbox
                    disabled={disabled}
                    checked={!!includeSon[rootPk]}
                    onChange={value => {
                        if (value) {
                            this.setState({ includeAll: { ...includeAll, [rootPk]: false } });
                        }
                        this.setState({ includeSon: { ...includeSon, [rootPk]: value } });
                    }}
                />
                <span className='include-son' title={json['container-transfer-0007'] || '包含直接下级'}>
                    {json['container-transfer-0007'] || '包含直接下级'}
                </span>
            </span>
        );
    }
    // 左侧树
    renderLeftTree = () => {
        const {
            syncTree,
            leftTreeMoudleId,
            disabled,
            notFoundContent,
            showInclude,
            prefixCls = 'ncc-transfer',
        } = this.props;
        const {
            json,
            leftAllNum,
        } = this.state;
        const notFoundDom = notFoundContent || json['container-transfer-0003'];
        return (
            <div className='ncc-transfer-list-body'>
                <div className="ncc-transfer-list-content">
                    {syncTree.createSyncTree({
                        treeId: leftTreeMoudleId,
                        checkable: true,
                        showLine: true,
                        disabledSearch: disabled,
                        expandedKeys: ['root'],
                        needEdit: false, //是否需要编辑节点功能，默认为true,可编辑；false：不可编辑
                        draggable: false,
                        needDrop: false,
                        searchType: 'filtration',
                        checkStrictly: showInclude,
                        mustExpandable: true,
                        checkWithCache: true,
                        noCheckWhenSelect: true,
                        onCheckEve: this.onCheckEveByLeft,
                        onSetTreeDataEve: this.onSetTreeDataEveByLeft,
                        searchChangeEve: this.searchChangeEveByLeft,
                        clearSearchVal: this.clearSearchValByLeft,
                    })}
                </div>
                {leftAllNum === 0 && (
                    <div
                        className={`${prefixCls}-list-body-not-found ${leftAllNum === 0 ? 'show' : ''}`}
                    >
                        <i className="no-data" />
                        <span>{notFoundDom}</span>
                    </div>
                )}
            </div>
        );
    }
    // 右侧头部
    renderRightHeader = () => {
        const { disabled } = this.props;
        const {
            json,
            rightAllNum,
            rightCheckedNum,
            currentRightAllNum,
            currentRightCheckedNum,
        } = this.state;
        return (
            <div className="ncc-transfer-list-header">
                <Checkbox
                    fieldid={getSysFieldid('transfer_header_right')}
                    disabled={disabled}
                    checked={
                        currentRightCheckedNum &&
                        currentRightCheckedNum ===
                        currentRightAllNum
                    }
                    indeterminate={
                        currentRightCheckedNum &&
                        currentRightCheckedNum <
                        currentRightAllNum
                    }

                    onChange={this.onRightCheckChange}
                />
                <span className="ncc-transfer-list-header-selected">
                    {json['container-transfer-selected']}
                    {`(${rightCheckedNum}/${rightAllNum})`}
                </span>
            </div>
        );
    }
    // 右侧树
    renderRightTree = () => {
        const {
            syncTree,
            rightTreeMoudleId,
            disabled,
            notFoundContent,
            prefixCls = 'ncc-transfer',
        } = this.props;
        const {
            json,
            rightAllNum,
        } = this.state;
        const notFoundDom = notFoundContent || json['container-transfer-0003'];
        return (
            <div className="ncc-transfer-list-body">
                <div className="ncc-transfer-list-content">
                    {syncTree.createSyncTree({
                        treeId: rightTreeMoudleId,
                        checkable: true, // 是否显示复选框
                        showLine: true,
                        disabledSearch: disabled, // 禁用搜索框
                        expandedKeys: ['root'], // 选中节点
                        needEdit: false, // 是否需要编辑节点功能，默认为true,可编辑；false：不可编辑
                        draggable: false,
                        needDrop: false,
                        searchType: 'filtration',
                        mustExpandable: false,
                        checkWithCache: true,
                        checkStrictly: false,
                        noCheckWhenSelect: true,
                        onCheckEve: this.onCheckEveByRight,
                        onSetTreeDataEve: this.onSetTreeDataEveByRight,
                        searchChangeEve: this.searchChangeEveByRight,
                        clearSearchVal: this.clearSearchValByRight,
                    })}
                </div>
                {rightAllNum === 0 && (
                    <div
                        className={`${prefixCls}-list-body-not-found ${rightAllNum === 0 ? 'show' : ''}`}
                    >
                        <i className="no-data" />
                        <span>{notFoundDom}</span>
                    </div>
                )}
            </div>
        );
    }

    render() {
        let {
            className = 'ncc-transfer-share',
            prefixCls = 'ncc-transfer',
            showInclude,
        } = this.props;

        const cls = classNames(className, prefixCls, 'ncc-transfer-share');
        return (
            <div className={cls} fieldid={getSysFieldid('transfer_area')}>
                <div className="ncc-transfer-list" fieldid={getSysFieldid('left_area')} >
                    {this.renderLeftHeader()}
                    {showInclude && this.renderInclude()}
                    {this.renderLeftTree()}
                </div>

                {this.renderOperation()}

                <div className="ncc-transfer-list" fieldid={getSysFieldid('right_area')} >
                    {this.renderRightHeader()}
                    {this.renderRightTree()}
                </div>
            </div>
        );
    }
}

TreeToTreeTransfer.propTypes = {
    className: PropTypes.string, // 样式名
    notFoundContent: PropTypes.string, // 暂无数据显示内容
    leftTreeMoudleId: PropTypes.string, // 左侧树模块id
    rightTreeMoudleId: PropTypes.string, // 右侧树模块id
    selectedPks: PropTypes.array, // 已选数据
    tabNames: PropTypes.array, // 选项卡名称
    tabPks: PropTypes.array, // 选项卡主键
    activeKey: PropTypes.string, // 当前页签
    showInclude: PropTypes.bool, // 是否显示包含选项
    operations: PropTypes.array, // 穿梭操作符 
    disable: PropTypes.bool, // 禁用所有功能
};

TreeToTreeTransfer.defaultProps = {
    className: '',
    leftTreeMoudleId: '',
    rightTreeMoudleId: '',
    selectedPks: [],
    tabNames: [],
    tabPks: [],
    activeKey: '',
    disable: false,
    showInclude: false,
    operations: ['', '', '', '', '', '', '', ''],
    renderOperation: () => '', //自定义操作,
};
